import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyDigitalFormsYesNoListSvg = lazy(() => import('./svg-components/digital-forms-yes-no-list-svg'));

const DigitalFormsYesNoListSvg = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyDigitalFormsYesNoListSvg {...rest} />
  </Suspense>
);

export default DigitalFormsYesNoListSvg;
